export default __webpack_public_path__ + "5b299034d01b695e49d9f7a276a24b75.png";